import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
//import { Autocomplete, Box, Card, DatePicker, ValidatorForm } from 'components'; // Assuming DatePicker is a custom component

import DashboardServices from 'services/DashboardServices';

import CardComponent from './CardComponent';

const ImportantStatus = ({filters}) => {
   /*  const [params, setParams] = useState({
        //from_date: moment().subtract(15, 'days').toISOString(),
        // to_date: moment().toISOString()
    }); */
    const [data, setData] = useState({
        "incidents_pending": 0,
        "tasks_to_be_resolved": 0,
        "pending_root_cause_analysis": 0,
        "pending_audits": 0,
        "completed_audits": 0,
        "pending_risk_assessments": 0
    });

    const getData = useCallback(async () => {
        const response = await DashboardServices.getImportantStatus(filters);
        if (response.success) {
            setData(response?.data || []);
        }
    }, [filters]);

    useEffect(() => {
        getData();
    }, [getData]);


  /*   const handleDateChange = (field, date) => {
        setParams({ ...params, [field]: date });
    }; */


   /*  const containerStyle = {
        borderRadius: '8px',
    };
 */
    return (
        <div className='w-full'>
            {/*  <ValidatorForm>
                <Grid container spacing={2} columns={10}>
                   
                    <Grid item size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
                        <DatePicker
                            label="From Date"
                            value={new Date(params.from_date)}
                            onChange={(date) => handleDateChange('from_date', date)}
                        />
                    </Grid>
                    <Grid item size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
                        <DatePicker
                            label="To Date"
                            value={new Date(params.to_date)}
                            onChange={(date) => handleDateChange('to_date', date)}
                        />
                    </Grid>
                </Grid>
            </ValidatorForm> */}


            <Grid container spacing={2} columns={10}>
                <Grid item size={{ lg: 2, md: 2, sm: 5, xs: 5 }}>
                    <CardComponent
                        color="linear-gradient(135deg, #913fdc, #803db9)"
                        //icon={<PersonIcon />}
                        title="Pending Incidents"
                        value={data.incidents_pending}
                        unit=""
                    //percentage={60}
                    />
                </Grid>
               <Grid item size={{ lg: 2, md: 2, sm: 5, xs: 5 }}>
                    <CardComponent
                        color="linear-gradient(135deg, #2da7e6, #457beb)"
                        //icon={<PersonIcon />}
                        title="Pending Tasks"
                        value={data.tasks_to_be_resolved}
                        unit=""
                    //percentage={60}
                    />
                </Grid>
                <Grid item size={{ lg: 2, md: 2, sm: 5, xs: 5 }}>
                    <CardComponent
                        color="linear-gradient(135deg, #e99b33, #c26e00)"
                        //icon={<PersonIcon />}
                        title="Pending Analysis"
                        value={data.incidents_pending}
                    //unit="人"
                    //percentage={60}
                    />
                </Grid>

                <Grid item size={{ lg: 2, md: 2, sm: 5, xs: 5 }}>
                    <CardComponent
                        color="linear-gradient(135deg, #2dd654, #00771c)"
                        //icon={<PersonIcon />}
                        title="Pending Audits"
                        value={data.pending_audits}
                    //unit="人"
                    //percentage={60}
                    />
                </Grid>

               <Grid item size={{ lg: 2, md: 2, sm: 10, xs: 10 }}>
                    <CardComponent
                        color="linear-gradient(135deg, #31baac, #216470)"
                        backgroundImage="/assets/siteLogo/logo.png"
                        title="Pending Risk Assessments"
                        value={data.pending_risk_assessments}
                        unit=""
                    // percentage={75}
                    />
                </Grid>


            </Grid>
        </div>
    );
};

export default ImportantStatus;